/**
 * 全国态势地图 · 大区（六大区）行政区划映射
 *
 * 设计稿左侧筛选第三组为「大区」：[华东] [华南] [华北] [西南] [西北] [东北]。
 * 后端项目只有 provinceCode（省级 adcode），没有大区字段，
 * 因此这里用标准行政区划归属做「省码 → 大区」静态映射，纯前端筛选。
 *
 * ⚠️ 这不是业务造数：大区归属是公开的行政区划事实，不涉及项目指标。
 */

export const REGIONS = ['华东', '华南', '华北', '西南', '西北', '东北'] as const;

export type Region = (typeof REGIONS)[number];

/** 大区 → 省级 adcode 集合 */
export const REGION_PROVINCE_CODES: Readonly<Record<Region, readonly string[]>> = {
  华东: ['310000', '320000', '330000', '340000', '350000', '360000', '370000'],
  华南: ['440000', '450000', '460000'],
  华北: ['110000', '120000', '130000', '140000', '150000'],
  西南: ['500000', '510000', '520000', '530000', '540000'],
  西北: ['610000', '620000', '630000', '640000', '650000'],
  东北: ['210000', '220000', '230000'],
};

/** 省码是否属于某大区 */
export function provinceInRegion(provinceCode: string, region: string): boolean {
  const codes = REGION_PROVINCE_CODES[region as Region];
  return codes ? codes.includes(provinceCode) : false;
}

/**
 * 省级 adcode → 省名（公开行政区划事实，非业务造数）。
 *
 * 供顶栏面包屑（总部 → 省）在下钻后展示省名，避免为取一个名字再拉一次接口。
 */
export const PROVINCE_NAME_BY_CODE: Readonly<Record<string, string>> = {
  '110000': '北京市',
  '120000': '天津市',
  '130000': '河北省',
  '140000': '山西省',
  '150000': '内蒙古自治区',
  '210000': '辽宁省',
  '220000': '吉林省',
  '230000': '黑龙江省',
  '310000': '上海市',
  '320000': '江苏省',
  '330000': '浙江省',
  '340000': '安徽省',
  '350000': '福建省',
  '360000': '江西省',
  '370000': '山东省',
  '410000': '河南省',
  '420000': '湖北省',
  '430000': '湖南省',
  '440000': '广东省',
  '450000': '广西壮族自治区',
  '460000': '海南省',
  '500000': '重庆市',
  '510000': '四川省',
  '520000': '贵州省',
  '530000': '云南省',
  '540000': '西藏自治区',
  '610000': '陕西省',
  '620000': '甘肃省',
  '630000': '青海省',
  '640000': '宁夏回族自治区',
  '650000': '新疆维吾尔自治区',
  '710000': '台湾省',
  '810000': '香港特别行政区',
  '820000': '澳门特别行政区',
};
